module.exports = __webpack_public_path__ + "70c9e993fef1d0134f05372295c7cd19.svg";